// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"64b16d3b","453":"de969743","455":"7d783365","977":"c43b740d"}[chunkId] + ".chunk.js";
};